var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { required } from "../../utils/validation";
var SelectDropdown = function (props) {
    var _a = __read(useState(), 2), selectOption = _a[0], setselectOption = _a[1];
    var _b = __read(React.useState(props.defaultValue || ""), 2), value = _b[0], setValue = _b[1];
    // const handleMouseOut = (e: any) => {
    //     if (props.onMouseOut) {
    //       e.currentTarget.blur();
    //       props.onMouseOut(e.target.value);
    //     }
    //   };
    function isRequired(value) {
        return !props.required || (props.required && !!required(value));
    }
    function handleBlur(e) {
        setFocusClass("");
        var errorObj = {};
        if (props.required) {
            errorObj = __assign(__assign({}, errorObj), { required: isRequired(value) });
        }
        props === null || props === void 0 ? void 0 : props.onBlur(errorObj, e);
    }
    React.useEffect(function () {
        if (props.defaultValue !== undefined && value !== props.defaultValue) {
            setValue(props.defaultValue);
        }
    }, [props.defaultValue]);
    var _c = __read(React.useState(""), 2), focusClass = _c[0], setFocusClass = _c[1];
    return (React.createElement("div", { className: "col" },
        React.createElement("div", { className: props.className },
            React.createElement("div", { className: props.placeholderClassName +
                    (props.errorText ? " error" : focusClass) }, value === "" && props.lable && (React.createElement(React.Fragment, null,
                React.createElement("label", { htmlFor: props.id }, props.placeholder),
                props.required && React.createElement("span", { className: "star" }, "*")))),
            React.createElement("select", { className: "form-control", defaultValue: value, id: props.id, name: props.name, onChange: props.onChangeEvent, onFocus: function () { return setFocusClass(" focus"); }, required: props.required, 
                //    onMouseOut={handleMouseOut}
                onBlur: function (e) { return handleBlur(e); } }, props.dropdownOptions.map(function (option, index) {
                return option.value ? (React.createElement("option", { key: index, value: option.value }, option.display)) : (React.createElement(React.Fragment, null));
            })),
            React.createElement("span", { className: props.downarrow })),
        props.errorText && React.createElement("p", { className: "help_text red" }, props.errorText)));
};
export default SelectDropdown;
